// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rectangle":"_10IulR","text":"_3wWNcI"};